import { lazy, Suspense } from "react";
import Footer from "@/components/Footer";
import PageTransition from "@/components/PageTransition";
import SEOHead from "@/components/SEOHead";
import HeroSection from "@/components/home/HeroSection";
import AboutSection from "@/components/home/AboutSection";

// Lazy load below-fold sections to reduce initial JS payload
const DualPathways = lazy(() => import("@/components/home/DualPathways"));
const HowItWorks = lazy(() => import("@/components/home/HowItWorks"));
const WhatYouGet = lazy(() => import("@/components/home/WhatYouGet"));
const TrustSection = lazy(() => import("@/components/home/TrustSection"));
const CTASection = lazy(() => import("@/components/home/CTASection"));

const Index = () => {
  return (
    <PageTransition><div className="min-h-screen">
      <SEOHead title="Studio Skandal — Przestrzeń Eventowa w Centrum Warszawy" description="Studio Skandal – 400 m², 3 poziomy, pełna prywatność. Eventy, imprezy firmowe, sesje foto w centrum Warszawy." />
      <main>
        <HeroSection />
        <AboutSection />
        <Suspense fallback={null}>
          <DualPathways />
          <HowItWorks />
          <WhatYouGet />
          <TrustSection />
          <CTASection />
        </Suspense>
      </main>
      <Footer />
    </div></PageTransition>
  );
};

export default Index;
